import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { CRM_RECORD_ROUTE, crmObjectFromSlug, SALESFORCE_ID_PATTERN } from "../../lib/crm";
import { callRecord } from "../../lib/telephony/callRecord";
import type { DialRecord } from "../../lib/telephony/phoneEngine";

/** The CRM record whose page is open, when a call can be linked to it; null on any other page or id. */
export const useOpenCrmRecord = (): DialRecord | null => {
  const { pathname } = useLocation();
  return useMemo(() => {
    const params = matchPath(CRM_RECORD_ROUTE, pathname)?.params;
    const object = crmObjectFromSlug(params?.objectSlug);
    if (!object || !params?.salesforceId || !SALESFORCE_ID_PATTERN.test(params.salesforceId)) return null;
    return callRecord({ object, salesforceId: params.salesforceId }) ?? null;
  }, [pathname]);
};
